import { render, staticRenderFns } from "./ZahnarztPraxis.vue?vue&type=template&id=37219e22&"
import script from "./ZahnarztPraxis.vue?vue&type=script&lang=js&"
export * from "./ZahnarztPraxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports